import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result, SortMode } from "../../../../interfaces";
import { Find } from "../../../../controllers/products";
import { Adapter } from "../../../../shared/adapter";
import { ProductAdapter } from "../../../../adapter/products-adapter";

export const FETCH_DATA_PRODUCTS_REQUEST = "FETCH_DATA_PRODUCTS_REQUEST";
export const FETCH_DATA_PRODUCTS_SUCCESS = "FETCH_DATA_PRODUCTS_SUCCESS";
export const FETCH_DATA_PRODUCTS_FAILURE = "FETCH_DATA_PRODUCTS_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataProductsRequest = () => {
  return {
    type: FETCH_DATA_PRODUCTS_REQUEST,
  };
};

const fetchDataProductsSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_PRODUCTS_SUCCESS,
    payload: data,
  };
};

const fetchDataProductsFailure = (error: any) => {
  return {
    type: FETCH_DATA_PRODUCTS_FAILURE,
    payload: error,
  };
};

export const find = (page: number, pageSize: number, query: Query) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataProductsRequest());
    try {
      const response = await Find("products", query, page, pageSize);
      try {
        const values = Adapter.from(response.data).to((value) =>
          new ProductAdapter(value).adapt()
        );
        console.log("values products", values);
      } catch (error) {
        console.log(error);
      }

      dispatch(
        fetchDataProductsSuccess({
          meta: response.meta,
          values: Adapter.from(response.data).to((value) =>
            new ProductAdapter(value).adapt()
          ),
        })
      );
    } catch (error: any) {
      dispatch(fetchDataProductsFailure(error.message));
    }
  };
};
